const styles = (theme) => ({
  searchTitle: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
    letterSpacing: 0.5,
  },
  checkoutTitle: {
    textTransform: 'capitalize',
    letterSpacing: 0.5,
  },
  addressText: {
    lineHeight: 1.3,
    color: theme.color.grey_8A,
    letterSpacing: 0.16,
  },
  addressContainer: {
    marginBottom: 20,
  },
});

export default styles;
